import * as React from 'react';
import {Tooltip} from '@mui/material';
import {Button} from '@material-ui/core';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import {Edit} from '@mui/icons-material';
import PaymentsSave from './PaymentsSave';
import DeleteAlert from '../components/DeleteAlert';
import Alert from '../components/Alert';
import {API_URL} from '../utils/EnvVars';
import axios from 'axios';


export default function BasicTable(props) {
  const childRefCaseItem = React.useRef();
  const childRefAlert = React.useRef(); 
  ///const childRefCaseJobs = React.useRef();  
  const [severityAlert, setSeverityAlert] = React.useState("error");
  const [alertMessage, setAlertMessage] = React.useState("");

  const [rows, setRows] = React.useState([]);
  const [itemsObj, setItemsObj] = React.useState({});
  

  React.useEffect(() => {
    setRows(props.rows);
  }, [props.rows]);

  function add() {
    setItemsObj(null);
    childRefCaseItem.current.handleClickOpen();
  }

  function edit(obj) {
    setItemsObj(obj);
    childRefCaseItem.current.handleClickOpen();
  }

  function updatedList(list){
    setRows(list);
    props.paymentsList(list);
  }

  // function caseJobs(obj) {
  //   setItemsObj(obj);
  //   childRefCaseJobs.current.handleClickOpen();
  // }
  
  function deleteNow(obj){
		if(obj && props.userObj.token){
			let axiosHeader = {
					headers: {
            'Content-Type': 'multipart/mixed',
            'device': 'web',
            'registerId': props.userObj.registerId,
            'uid': props.userObj.loginId,
            'fullName': props.userObj.fullName,
            'token': props.userObj.token,
				}
			}; 

		  const data = new FormData();
		  data.append('paymentId', obj.autoId);
      data.append('relatedToId', obj.relatedToId);
      data.append('relatedTo', obj.relatedTo);      
      
		  axios.post(API_URL+'/crm-delete-payments', data, axiosHeader)
				.then((response) => {

        if(response.data.responseTxt==="success"){
					setSeverityAlert("success");					
					setAlertMessage("Payment has been deleted.");
          childRefAlert.current.handleClickOpen();
			  	setRows(response.data.list);
					return false;
				}else{
		  		setSeverityAlert("error");
					setAlertMessage("Payment could not be deleted.");	
          childRefAlert.current.handleClickOpen();		
					return false;
				}
			})
				.catch((error) => {
		  		setSeverityAlert("error");
					setAlertMessage(""+error);	
          childRefAlert.current.handleClickOpen();		
					return false;
				})

		}		
		
	}

  return (<>

      <div style={{textAlign:'center',marginBottom:10}}>
            <Button onClick={() => {add()}} style={{textTransform:'none',maxHeight:25}} size="small" variant="outlined" >Add Payment</Button>
      </div>

    {(rows && rows.length>0)?
    <TableContainer component={Paper}>
      <Table sx={{ width: 'auto' }} aria-label="simple table">
        <TableHead>
          <TableRow>            
            <TableCell sx={{width: 120}} >Payment Number</TableCell>
            <TableCell sx={{width: 120}} >Amount</TableCell>
            <TableCell sx={{width: 120}} >Date</TableCell>
            <TableCell sx={{width: 120}} >Mode</TableCell> 
            <TableCell sx={{width: 125}} >Status</TableCell> 
            <TableCell sx={{width: 150}} >Transaction Id</TableCell>
            <TableCell sx={{width: 150}} >Bank</TableCell>
            <TableCell>Remarks</TableCell> 
            <TableCell sx={{ width: 80 }}>&nbsp;</TableCell>           
          </TableRow>
        </TableHead>
        <TableBody>
          {rows.map((row) => (
            <TableRow
              key={row.autoId}
              sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
              <TableCell component="th" scope="row" style={{verticalAlign:'top'}} >
                  {row.paymentNumber}
              </TableCell>
              <TableCell style={{verticalAlign:'top',whiteSpace: 'nowrap'}} ><i className='fa fa-inr'></i> {row.amount}</TableCell> 
              <TableCell style={{verticalAlign:'top',whiteSpace: 'nowrap'}} >{row.paymentDate}</TableCell>
              <TableCell style={{verticalAlign:'top',whiteSpace: 'nowrap'}} >{row.paymentMode}</TableCell>
              <TableCell style={{verticalAlign:'top',whiteSpace: 'nowrap'}} >{row.status}</TableCell>
              <TableCell style={{verticalAlign:'top',whiteSpace: 'nowrap'}} >{row.transactionId}</TableCell>
              <TableCell style={{verticalAlign:'top',whiteSpace: 'nowrap'}} >{row.bankAccountName} {row.bankAccountNumber} {row.bankName}</TableCell> 
              <TableCell style={{verticalAlign:'top',whiteSpace: 'nowrap'}} >{row.remarks}</TableCell>                           
              <TableCell align="center" style={{verticalAlign:'top'}}>
              {(props.privileges && (props.privileges.indexOf("update")>-1))?<>
                    <Tooltip title={'Modified By: '+row.lastModifiedAlias+', '+row.lastModifiedDateTime} arrow>
                        <Edit onClick={()=>{edit(row)}} className='iconGraySmall'  />
                    </Tooltip><br/>
              </>:null}  
              {(props.privileges && props.privileges.indexOf("delete")>-1)?<>                        
                    <DeleteAlert deleteNow={deleteNow} dataObj={row} text={'Are you sure, You want to delete payment.'} className='iconGraySmall' />
              </>:null}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </TableContainer>
    :null}

    {(!rows || rows.length<1)?<div className='nrfbox' >No payment found</div>:null}

    <Alert severityAlert={severityAlert} alertMessage={alertMessage} ref={childRefAlert} />              
    <PaymentsSave dataObj={itemsObj} relatedTo={props.relatedTo} relatedDataObj={props.relatedDataObj} updatedList={updatedList} userObj={props.userObj} ref={childRefCaseItem} />

    
  </>);
}
